import { Plus, X } from 'lucide-react';
import { Button } from '../ui/button';
import { uid } from '../../lib/uid';

export default function ExclusionsNotes({ exclusions, onUpdate }) {
  const updateItem = (id, value) => {
    const updated = exclusions.map(item => item.id === id ? { ...item, text: value } : item);
    onUpdate(updated);
  };

  const addItem = () => {
    onUpdate([...exclusions, { id: uid(), text: '' }]);
  };

  const removeItem = (id) => {
    onUpdate(exclusions.filter(item => item.id !== id));
  };

  return (
    <div
      className="py-8 border-t"
      style={{ borderColor: 'rgba(201,168,76,0.2)' }}
      data-testid="exclusions-notes"
    >
      <h2 className="section-heading">Exclusions & Notes</h2>

      <div className="space-y-2">
        {exclusions.map((item) => (
          <div key={item.id} className="flex items-start gap-3 group" data-testid={`exclusion-${item.id}`}>
            <span className="text-[#c9a84c] mt-2 text-sm flex-shrink-0">&#8226;</span>
            <input
              value={item.text}
              onChange={e => updateItem(item.id, e.target.value)}
              className="editable-field text-sm flex-1"
              placeholder="Enter exclusion or note"
              data-testid={`exclusion-input-${item.id}`}
            />
            <button
              onClick={() => removeItem(item.id)}
              className="text-[#6b7280] hover:text-[#dc2626] transition-colors opacity-0 group-hover:opacity-100 mt-1"
              data-testid={`exclusion-delete-${item.id}`}
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>

      <Button
        variant="outline"
        size="sm"
        onClick={addItem}
        className="mt-4 border-[#c9a84c] text-[#c9a84c] hover:bg-[#c9a84c]/10"
        data-testid="add-exclusion-btn"
      >
        <Plus className="w-4 h-4 mr-1" />
        Add Exclusion
      </Button>
    </div>
  );
}
